import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class Image extends React.Component {
  constructor(props) {
    super(props)

    this.config = {
      types: [],
      modifiers: [
        'proportion-3-2',
        'proportion-1-1',
        'proportion-3-4',
        'proportion-1-2'
      ],
      states: []
    }

    this.multiplies = {
      "mdn-Image--3-2": 2/3,
      "mdn-Image--1-1": 1/1,
      "mdn-Image--3-4": 4/3,
      "mdn-Image--1-2": 2/1
    }

    this.state = {
      style: {
        width : 'auto',
        height : 'auto'
      }
    }

    this.updateWidth = this.updateWidth.bind(this)
    this.handleImageLoaded = this.handleImageLoaded.bind(this)
  }
  
  updateWidth() {
    if(!this.mainImg) return;

    this.setState({
      style: {
        width: `auto`,
        height: `auto`
      }
    })
    
    const width = this.mainImg.width;
    this.setState({
      style: {
        width: `${width}px`,
        height: `${width * this.multiplies[this.proportion]}px`
      }
    })
  }

  handleImageLoaded(evt) {
    this.mainImg = evt.target
  }

  componentWillMount() {
    window.addEventListener("resize", this.updateWidth)
  }

  render() {
    const { src, srcMobile, srcTablet, alt , ...rest } = this.props
    const className = resolveProps(this.props, this.config, 'Image').replace(/proportion-/g, '');
    this.proportion = className.replace(/mdn-Image ?/, "").replace(/ /, '')
    const fixedProps = clearProps(rest)
    return <picture {...fixedProps} style={{
      width: this.state.style.width,
      height: this.state.style.height,
    }} className={className}>
      <source className="mdn-Image-asset" srcSet={srcMobile || src} media="(max-width: 768px)" />
      <source className="mdn-Image-asset" srcSet={srcTablet || src} media="(max-width: 991px)" />
      <img className="mdn-Image-asset" src={src} alt={alt} onLoad={this.handleImageLoaded} />
    </picture>
  }
}

Image.propTypes = {
  etc : PropTypes.object,
  data : PropTypes.object
}